import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProjectDetailsComponent } from './project-details/project-details.component';

const routes: Routes = [
	{
		path: 'project_details/:id',
		data: { type: ['BROKER', 'SHIPPER'] },
		children: [
			{
				path: '',
				component: ProjectDetailsComponent,
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	providers: [],
})
export class ProjectRoutingModule {}
